import React, { InputHTMLAttributes } from 'react';
import { Field, Label, Input as HeadlessInput, Description } from '@headlessui/react';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label: string;
  error?: string;
}

export function Input({ label, error, className = '', ...props }: InputProps) {
  return (
    <Field className="flex flex-col w-full">
      <Label className="mb-1.5 text-sm font-semibold text-slate-700 data-[disabled]:opacity-50 transition-opacity">
        {label}
      </Label>
      <HeadlessInput
        className={`
          w-full px-4 py-2.5 bg-white border rounded-lg text-sm text-slate-900 
          placeholder-slate-400 shadow-sm transition-all duration-200 outline-none
          /* Headless UI Data Attributes for smooth transitions */
          data-[focus]:ring-2 data-[focus]:ring-brand-500/20 data-[focus]:border-brand-500
          data-[hover]:border-slate-400 data-[disabled]:bg-slate-50 data-[disabled]:text-slate-500
          ${error ? 'border-red-500 data-[focus]:ring-red-500/20 data-[focus]:border-red-500' : 'border-slate-300'}
          ${className}
        `}
        {...props}
      />
      {error && (
        <Description className="mt-1.5 text-xs font-medium text-red-500 transition-all">
          {error}
        </Description>
      )}
    </Field>
  );
}